import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useDevelopmentEffect } from "../../hooks/_internal/useDevelopmentEffect.js";
import { BaseButton } from "./internal/BaseButton.js";
const Button = /*#__PURE__*/ forwardRef(({ startIcon, endIcon, iconProps, children, ...props }, ref)=>{
    useDevelopmentEffect(()=>{
        if (startIcon && endIcon) console.error("[Button] Start and end icons cannot be used at the same time. As both were set only the start icon will be rendered.");
    }, [
        startIcon,
        endIcon
    ]);
    return /*#__PURE__*/ jsx(BaseButton, {
        ...props,
        startAdornment: startIcon ? /*#__PURE__*/ jsx(BaseButton.ButtonAdornmentIcon, {
            icon: startIcon,
            ...iconProps
        }) : void 0,
        endAdornment: !startIcon && endIcon ? /*#__PURE__*/ jsx(BaseButton.ButtonAdornmentIcon, {
            icon: endIcon,
            ...iconProps
        }) : void 0,
        ref: ref,
        children: children
    });
});
Button.displayName = 'Button';
export { Button };
